export enum ProductCurrencyEnum {
  REAL = 1,
  DOLLAR = 2,
  EURO = 3
}
